export var UPLOADCARE_CDN_URL = 'https://cdn.uc.assets.prezly.com';
export var UPLOADCARE_FILE_DATA_KEY = 'prezly:data';
export var UPLOADCARE_IMAGE_SIZE_LIMIT = 78643200;